module.exports = __webpack_public_path__ + "static/img/qiangcha2.68ec529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/qiangcha2.png
// module id = Dan6
// module chunks = 24